define([
	"dojo/_base/declare",
	"csi/gallery/Widget",
	"Apparel/StructureItemMixin"
], function(declare,Widget,StructureItemMixin) {

	return declare([Widget, StructureItemMixin], {
		_resolveView: function() {
			// summary: resolve view path and editability
			this._resolveViewFilter(this);
			this.inherited(arguments);
		}
	});
});